import { createFetchWrapper } from './fetch-wrapper-core';
import { ensureFreshToken, recordExpiry } from '@KTXC/services/authManager';

export const fetchWrapper = createFetchWrapper({
  beforeRequest: ensureFreshToken,
  afterResponse: (data) => recordExpiry(data?.expires_in),
});
